import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecord = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.5,
		fill: "#E7EFFD",
		stroke: "#3574F0"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.92995 8.405H9.02495L10.925 11.5H9.77495L7.92995 8.405ZM5.69995 4.5H8.58495C9.04828 4.5 9.45328 4.58667 9.79995 4.76C10.15 4.93 10.42 5.17167 10.61 5.485C10.8 5.795 10.895 6.15833 10.895 6.575C10.895 6.98833 10.7983 7.35333 10.605 7.67C10.4116 7.98667 10.1383 8.23167 9.78495 8.405C9.43162 8.575 9.01828 8.66 8.54495 8.66H6.69995V11.5H5.69995V4.5ZM8.55995 7.77C8.81995 7.77 9.04662 7.72167 9.23995 7.625C9.43328 7.52833 9.58328 7.39 9.68995 7.21C9.79662 7.03 9.84995 6.81833 9.84995 6.575C9.84995 6.335 9.79662 6.12667 9.68995 5.95C9.58328 5.77 9.43328 5.63167 9.23995 5.535C9.04662 5.43833 8.81995 5.39 8.55995 5.39H6.69995V7.77H8.55995Z",
		fill: "#3574F0"
	})]
});
export default SvgRecord;
